import { useEffect, useState } from "react";
export default function BasicFilterCheckbox({
  list,
  handleClick,
  active = [],
    type,
    isLoading = false
}) {
  const [showList, setShowList] = useState(list);

  useEffect(() => {
    setShowList(list);
  }, [list]);

  const handleSearchInput = (value) => {
    let newList = list.filter(
      (a) => a?.name?.toLowerCase().indexOf(value.toLowerCase()) > -1
    );
    setShowList(newList);
  };

  return (
    <div className="space-y-4 h-full">
      <div className={"space-y-4 max-h-[300px] overflow-y-scroll"}>
        <div className={"border-b border-olaf-green-700 pb-6"}>
          <div
            className={
              "flex w-full h-[35px] bg-white mt-4 border border-olaf-green-700"
            }
          >
            <input
              placeholder={"Verfijn filter door te zoeken"}
              className={"w-full h-full px-2"}
              onChange={(e) => handleSearchInput(e.target.value)}
            />
            <img
              className={"h-full w-[35px] bg-white p-2"}
              src="/assets/icon/search.svg"
              alt="Search icon"
            />
          </div>
        </div>
        {showList?.map((option, optionIdx) => (
          <div key={option.value} className="flex items-center">
            <input
              id={`filter-${option.id}-${optionIdx}`}
              name={`${option.name}[]`}
              defaultValue={option.id}
              disabled={isLoading}
              type="checkbox"
              checked={active.some(
                (selectedColor) => selectedColor.id === option.id
              )}
              onChange={(e) => handleClick(e, type, option)}
              className="h-4 w-4 rounded border-olaf-green-700 text-indigo-600 focus:ring-indigo-500"
            />
            <label
              htmlFor={`filter-${option.id}-${optionIdx}`}
              className="ml-3 text-sm text-olaf-green-700"
            >
              {option.name} ({option?.count})
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
